import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=458e5e46"
import script from "./detailDialog.vue?vue&type=script&lang=ts"
export * from "./detailDialog.vue?vue&type=script&lang=ts"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=458e5e46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports